import { FC } from 'react';
import { getIsMobile } from '../../../../../utils/getIsMobile';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconPlus } from '../../../../icon/IconPlus';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { CpaTrialDisclaimer } from '../../../CpaTrialDisclaimer/CpaTrialDisclaimer';
import { ActionButton } from '../../../styles';
import { BookmarkStep } from '../../types';
import { SaveToCollectionFooterProps } from './types';

export const shouldShowSaveFooter = (step: BookmarkStep, isFavoritesEnabled: boolean) =>
    step === BookmarkStep.ADD_TO_NEW_COLLECTION ||
    (step === BookmarkStep.ADD_TO_EXIST_COLLECTION && isFavoritesEnabled);

export const SaveToCollectionFooter: FC<SaveToCollectionFooterProps> = ({
    step,
    onAddClick,
    onSubmit,
    values,
    isNotRegistered,
}) => {
    const t = useTranslation();
    const isMobile = getIsMobile().isMobile;

    const enabledSaveCollection =
        values.collectionName || (values.showInFeed && values.currentSuggest);

    if (step === BookmarkStep.ADD_TO_EXIST_COLLECTION) {
        return (
            <Flex direction="column" width="100%" pt={isMobile ? 1 : 0}>
                <ActionButton
                    color="secondary"
                    dataTestId={DataTestId.ADD_NEW_COLLECTION}
                    minHeight="46px"
                    spacing={1}
                    onClick={onAddClick}
                >
                    <IconPlus color="var(--color-primary)" fontSize={24} />
                    {t('Добавить коллекцию')}
                </ActionButton>
            </Flex>
        );
    }

    return (
        <Flex direction="column" width="100%" pt={isMobile ? 1 : 0}>
            <ActionButton
                dataTestId={DataTestId.SAVE_TO_NEW_COLLECTION_BUTTON}
                minHeight="46px"
                onClick={onSubmit}
                disabled={!enabledSaveCollection}
            >
                {t('Создать')}
            </ActionButton>
            {isNotRegistered ? <CpaTrialDisclaimer /> : null}
        </Flex>
    );
};
